import { default as Image } from '@react/shared/components/Image';
import {
  CARE_SCOUT_PRICING_PLANS_URL,
  CARE_SCOUT_PRICING_PLANS_UTM_PARAMS,
} from '@sly/core/constants';
import { CARE_SCOUT_PRICING_PLAN_IMAGE_URL } from '@sly/core/constants/image';
import { appendUTMToURL } from '@sly/frontend/common/helpers/url';
import React, { useCallback } from 'react';
import { Button } from 'sly/system';

function DynamicCarePlans() {
  const handleLearnMore = useCallback(() => {
    window.open(
      appendUTMToURL(
        CARE_SCOUT_PRICING_PLANS_URL,
        CARE_SCOUT_PRICING_PLANS_UTM_PARAMS.article
      ),
      '_blank'
    );
  }, []);
  return (
    <div className='mb-6 flex w-[calc(100%-2rem)] flex-col-reverse rounded bg-viridian-lighter-90 md:w-[var(--col6)] lg:w-[var(--col8)] lg:flex-row'>
      <div className='flex gap-7 p-6 pt-0 md:p-8'>
        <div className='flex flex-col gap-2'>
          <div className='font-t-s mt-8 md:mt-0 lg:mt-6'>
            Understand your care options
          </div>
          <div className='font-b-s'>
            With a personalized Care Plan, you’ll get clear guidance on care
            options and resources so you can find the right support.
          </div>
          <div className='mt-4 w-full md:w-auto'>
            <Button
              className='w-full px-8 md:w-auto'
              eventProps={{
                location: 'care-plans-article-page',
                text: 'learn more',
              }}
              onClick={handleLearnMore}
            >
              Learn more
            </Button>
          </div>
        </div>
      </div>

      <div className='z-1 m-8 mb-0 w-[218px] flex-shrink-0 overflow-hidden lg:h-[226px]'>
        <div className='relative h-[267px] w-full lg:h-full'>
          <Image
            path={CARE_SCOUT_PRICING_PLAN_IMAGE_URL}
            alt='carePricingPlans'
            fill
            className='object-cover object-top'
            priority
          />
        </div>
      </div>
    </div>
  );
}

export default DynamicCarePlans;
